export enum SegmentAdmissionNameEnum {
  '/company/models' = 'People - Models - Page View',
  '/add' = 'People - New Position - Page View',
}

export enum SegmentAdmissionTitlePage {
  '/company/models' = 'Modelos',
  '/home/' = 'Home Dashboard',
  '/company/benefits/' = 'Listagem Beneficios',
  '/add' = 'Criando um novo cadastro',
}

export enum SegmentAdmissionEventName {
  'add_model_btn_click' = 'People - New Model - Add Button Click',
  'new_model_modal_view' = 'People - New Model - Modal View',
  'model_editor_page_view' = 'People - Model Editor - Page View',
  'open_model_click' = 'People - Models - Open Model Click',
  'candidate_actions_btn_click' = 'People - Candidate Actions - Actions Button Click',
  'sign_signature_btn_blick' = 'People - Candidate Actions - Sign Signature Button Click',
  'resend_link_btn_click' = 'People - Candidate Actions - Resend Link Button Click',
  'export_documents_btn_click' = 'People - Candidate Actions - Export Documents Button Click',
  'send_admission_btn_click' = 'People - Candidate Actions - Send Admission Kit Button Click',
  'resend_link_modal_view' = 'People - Resend Link - Modal View',
  'resend_link_modal_view_success' = 'People - Resend Link - Success Modal View',
  'resend_btn_click' = 'People - Resend Link - Resend Button Click',
  'export_documents_modal_view' = 'People - Export documents - Modal View',
  'export_documents_export_btn_click' = 'People - Export documents - Export Button Click',
  'send_admission_kit_modal_view' = 'People - Send Admission Kit - Modal View',
  'send_admission_kit_send_btn' = 'People - Send Admission Kit - Send Button Click',
  'send_admission_kit_added_models' = 'People - Send Admission Kit - Add Models Modal View',
  'send_admission_kit_added_modal_view' = 'People - Send Admission Kit - Added Models Modal View',
  'send_admission_kit_success' = 'People - Send Admission Kit - Success Modal View',
  'adicionar_modelo' = 'People - New Model - Add Button Click',
  'page_novo_modelo' = 'People - New Model - Modal View',
  'page_editar_modelo' = 'People - Model Editor - Page View',
  'listar_templates' = 'People - Models - Open Model Click',
  'redo' = 'People - Model Editor - Redo Button Click',
  'undo' = 'People - Model Editor - Undo Button Click',
  'insertTable' = 'People - Model Editor - Insert Table Button Click',
  'imageUpload' = 'People - Model Editor - Insert Image Button Click',
  'home_export_btn_click' = 'People - Home - Export Button Click',
  'export_listing_modal_view' = 'People - Export Listing - Modal View',
  'export_listing_candidates_btn_click' = 'People - Export Listing - Candidates Button Click',
  'export_listing_benefits_btn_click' = 'People - Export Listing - Benefits Button Click',
  'export_listing_candidate_export_btn_click' = 'People - Export Listing - Candidate Export Button Click',
  'export_listing_benefits_export_btn_click' = 'People - Export Listing - Benefits Export Button Click',
  'export_payroll_modal' = 'People - Export To Payroll - Modal View',
  'export_payroll_btn_click' = 'People - Export To Payroll - Export Button Click',
  'export_generate_report_modal_ok' = 'People - Export Status - OK I Got It Button Click',
  'export_download_modal_view' = 'People - Export Status - Modal View',
  'export_download_modal_click' = 'People - Export Status - Download Link Click',
  'export_download_modal_close' = 'People - Export Status - Close Button Click',
  'export_download_modal_unavailable_close' = 'People - Export Status - Close Button Click',
  'settings_roles' = 'People - Export Roles - Modal View',
  'settings_departments' = 'People - Export Departments - Modal View',
  'settings_clinics' = 'People - Export Clinics - Modal View',
  'export_roles' = 'People - Export Roles - Export Button Click',
  'export_departments' = 'People - Export Departments - Export Button Click',
  'export_clinics' = 'People - Export Clinics - Export Button Click',
  'backup_request_button_click' = 'People - Request Data Backup - Request Backup Button Click',
  'backup_request_modal_view' = 'People - Request Data Backup - Modal View',
  'backup_request_try_again_button_click' = 'People - Request Data Backup - Try Again Button Click',
  'backup_request_security_tips' = 'People - Request Data Backup - Security Tips Link Click',
  'backup_request_download_button_click' = 'People - Request Data Backup - Download Button Click',
  'backup_download_modal_view' = 'People - Download Data Backup - Modal View',
  'refuse_btn_click' = 'People - Candidate Profile - Notification Refuse Button Click',
  'approve_btn_click' = 'People - Candidate Profile - Notification Approve Button Click',
  'notification_confirm_btn_click' = 'People - Candidate Profile - Notification Confirm Button Click',
  'new_position_btn_click' = 'People - New Position - New Position Button Click',
  'page_view_new_position' = 'Viewed People - New Position - Page View Page',
  'new_position_generate_btn_click' = 'People - New Position - Generate Position Button Click',
  'page_view_new_position_share' = 'Viewed People - New Position Share - Page View Page',
  'new_position_share_copy_btn_click' = 'People - New Position Share - Copy Button Click',
  'new_position_share_send_btn_click' = 'People - New Position Share - Send Button Click',
  'new_position_share_modal_view' = 'People - New Position Share - Modal View',
}

export enum SegmentAdmissionPageView {
  'home_pageview' = 'People - Home - Page View',
  'settings_roles' = 'People - Roles - Page View',
  'settings_departments' = 'People - Departments - Page View',
  'settings_clinics' = 'People - Medical Clinic - Page View',
  'data_backup' = 'People - Data Backup - Page View'
}
